import { Loader } from "@/components/common/Icons/Loader/Loader";
import { Translate } from "@/components/common/Translate/Translate";
import { useDailyQuota } from "@/modules/DailyQuota/hooks/useDailyQuota";
import { formatFileSize } from "@/utils/formatFileSize";
import Link from "next/link";
import { useRouter } from "next/router";
import { ReactNode } from "react";
import translatedRoutesSlugs from "translatedRouteSlugs";

export const MaxFileSizeIndicator = () => {
    const { userType, usageDetail, isLoading } = useDailyQuota();
    const router = useRouter();
    if (isLoading) {
        return (
            <div>
                <Loader height={20} />
            </div>
        );
    }
    if (!usageDetail) return null;
    const getCtaText = (): ReactNode => {
        const pricingLink =
            router.locale === "en"
                ? "/pricing"
                : `/${router.locale}/${translatedRoutesSlugs["/pricing"][router.locale || "en"]}`;
        if ((userType === "free" && usageDetail.isRegistered) || userType === "pro") {
            return (
                <span>
                    .{" "}
                    <Translate
                        keyName="common:upgrade-for-more"
                        linkRenderer={(label) => (
                            <Link href={pricingLink} className="underline" onClick={(e) => e.stopPropagation()}>
                                {label}
                            </Link>
                        )}
                    />
                    .
                </span>
            );
        }
        if (userType === "free") {
            return (
                <span>
                    .{" "}
                    <Translate
                        keyName="common:sign-up-for-more"
                        linkRenderer={(label) => (
                            <Link href={pricingLink} className="underline" onClick={(e) => e.stopPropagation()}>
                                {label}
                            </Link>
                        )}
                    />
                    .
                </span>
            );
        }
        return "";
    };
    return (
        <div>
            <Translate keyName="common:max-file-size" />: {formatFileSize(usageDetail.fileSizeLimit)}
            {getCtaText()}
        </div>
    );
};
